//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabrics', {
//        templateUrl: 'views/components/views/furnitureFabrics/furnitureFabrics.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'furnitureFabricsService', 'productService', 'logisticService', 'colorGrpsService', 'typeaheadService', function ($stateParams, stateService, utilityService, modalService, translateService, furnitureFabricsService, productService, logisticService, colorGrpsService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                furnitureFabricsId: furnitureFabricsId,
//                productGroupButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('prodgrps') }
//                ],
//                collectionButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('collections') }
//                ],
//                colourGroupButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('colorgrps') }
//                ],
//                fabricGroupButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('fabricsgrps') }
//                ],
//                edit: {},
//                selectListProductTypes: [],
//                selectListUnits: [],
//                selectListProductGroups: [],
//                selectListCompanies: [],
//                selectListProductionPlaces: [],
//                selectListStockPlaces: [],
//                selectListCollections: [],
//                selectListColourGroups: [],
//                selectListProdMeoMethods: [],
//                selectListProductChoices: [],
//                selectListFabricGroups: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await furnitureFabricsService.getEdit({ furniturefabrics_id: furnitureFabricsId }))[0];
//            }

//            async function loadProductTypes() {
//                vm.model.selectListProductTypes = await productService.listProductTypes();
//            }

//            async function loadUnits() {
//                vm.model.selectListUnits = await logisticService.listUnits();
//            }
            
//            async function loadProductGroups() {
//                vm.model.selectListProductGroups = await productService.listProductGroups();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadProductionPlaces() {
//                vm.model.selectListProductionPlaces = await logisticService.listProductPlaces();
//            }

//            async function loadCollections() {
//                vm.model.selectListCollections = await productService.listCollections();
//            }

//            async function loadColourGroupViews() {
//                vm.model.selectListColourGroups = await colorGrpsService.listColourGroupViews();
//            }

//            async function loadProdBeoMethods() {
//                vm.model.selectListProdMeoMethods = await logisticService.listProdBeoMethods();
//            }

//            async function loadProductChoices() {
//                vm.model.selectListProductChoices = await furnitureFabricsService.listProductChoices();
//            }

//            async function loadFabricGroups() {
//                vm.model.selectListFabricGroups = await furnitureFabricsService.listFabricGroups();
//            }

//            async function loadStocks() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.edit.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH MULTI PROCEDURE FUNCTION CALLS

//            vm.typeaheadSearch = function (value) {
//                if (utilityService.validateParmsValue(vm.model.edit.supplier_name, true) !== true) return;

//                var parms = {
//                    cust_name: vm.model.edit.supplier_name,
//                    filtertype: '',
//                    filtervalue: '',
//                    custtype: 'S',
//                    lastselect: 'SEARCH'
//                };

//                return typeaheadService.searchCustomer(parms);
//            }

//            vm.onSuplierNameCleared = function () {
//                vm.model.edit.supplier_no = '0';
//                vm.model.edit.supplier_name = '';
//            }

//            vm.onSuplierNameSelected = function (item) {
//                vm.model.edit.supplier_no = item.item_id;
//                vm.model.edit.supplier_name = item.item_name;
//            }

//            vm.onSuplierNameChanged = function (value) {
//                vm.model.edit.supplier_name = value;
//                if (!value) {
//                    vm.onSuplierNameCleared();
//                } else {
//                    let suplier = typeaheadService.selectListCustomers.find((item) => item.iten_name === vm.model.edit.supplier_name);
//                    if (suplier) {
//                        vm.onSuplierNameSelected(suplier);
//                    }
//                }
//            }

//            // #endregion TYPEAHEAD SEARCH MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                furnitureFabricsService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'custactsearch':
//                        go({
//                            filterfield: 'furniturefabrics_id',
//                            filtervalue: vm.model.edit.furniturefabrics_id,
//                            custacttype: 'A'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.businessco_no) !== true) return;

//                        vm.model.edit.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                        loadStocks();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadProductTypes();
//                loadUnits();
//                loadProductGroups();
//                loadCompanies();
//                loadProductionPlaces();
//                loadCollections();
//                loadColourGroupViews();
//                loadProdBeoMethods();
//                loadProductChoices();
//                loadFabricGroups();
//                loadStocks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
